import React, { useEffect, useState } from "react";

import { getLoggedInUser } from "../helpers/fakebackend_helper";
import { useNavigate } from "react-router-dom";

const Navdata = () => {
  const history = useNavigate();

  const [isDashboard, setIsDashboard] = useState(false);
  const [isContent, setIsContent] = useState(false);
  const [isUser, setIsUser] = useState(false);
  const [isItem, setIsItem] = useState(false);
  const [isMenuSetup, setIsMenuSetup] = useState(false);
  const [isCourseSetup, setIsCourseSetup] = useState(false);

  const [isIntell, setIsIntell] = useState(false);
  const [isBlog, setIsBlog] = useState(false);
  const [isMedia, setIsMedia] = useState(false);
  const [isTeam, setIsTeam] = useState(false);
  const [isCourse, setIsCourse] = useState(false);

  const [isPrivacy, setIsPrivacy] = useState(false);
  const [isTestimonial, setIsTestimonial] = useState(false);

  const [isBranch, setIsBranch] = useState(false);
  const [isDestination, setIsDestination] = useState(false);

  const [isTermCondition, setIsTermCondition] = useState(false);
  const [isAffiliated, setIsAffiliated] = useState(false);
  const [isStudentForms, setIsStudentForms] = useState(false);
  const [isSetting, setIsSetting] = useState(false);
  const [isWaiter, setIsWaiter] = useState(false);
  const [isTable, setIsTable] = useState(false);
  const [isFAQ, setIsFAQ] = useState(false);
  const [isPrivacySettings, setIsPrivacySettings] = useState(false);
  const [isConfig, setIsConfig] = useState(false);

  const [isWhoweare, setIsWhoWeAre] = useState(false);
  const [isMessage, setIsMessage] = useState(false);
  const [isWidget, setIsWidget] = useState(false);
  const authUser = getLoggedInUser();
  // console.log("authUserr", authUser);
  const userRole = authUser?.roles[0]?.toLowerCase();
  // console.log("🚀 ~ Navdata ~ userRole:", userRole);
  const isSuperAdmin = authUser.roles[0].includes("SuperAdmin");
  console.log("🚀 ~ Navdata ~ isSuperAdmin:", isSuperAdmin);
  const isOnshoreAdmin = authUser.roles[0].includes("OnshoreAdmin");
  const isOffshoreAdmin = authUser.roles[0].includes("OffshoreAdmin");
  const [isQuiz, setIsQuiz] = useState(false);
  // const isSuperAdmin = true;
  // console.log("isSuperAdmin", isSuperAdmin);
  // const isAdmin = true;

  const menuDynamicList = authUser?.subHeadingAccess || [];
  console.log("🚀 ~ Navdata ~ menuDynamicList:", menuDynamicList);

  const [iscurrentState, setIscurrentState] = useState("Dashboard");

  function updateIconSidebar(e) {
    if (e && e.target && e.target.getAttribute("subitems")) {
      const ul = document.getElementById("two-column-menu");
      const iconItems = ul.querySelectorAll(".nav-icon.active");
      let activeIconItems = [...iconItems];
      activeIconItems.forEach((item) => {
        item.classList.remove("active");
        var id = item.getAttribute("subitems");
        if (document.getElementById(id))
          document.getElementById(id).classList.remove("show");
      });
    }
  }

  useEffect(() => {
    document.body.classList.remove("twocolumn-panel");

    if (iscurrentState !== "Dashboard") {
      setIsDashboard(false);
    }

    if (iscurrentState !== "team-mgmt") {
      setIsTeam(false);
    }
    if (iscurrentState !== "faq") {
      setIsFAQ(false);
    }
    if (iscurrentState !== "testimonial") {
      setIsTestimonial(false);
    }
    if (iscurrentState !== "legal-policy") {
      setIsPrivacy(false);
    }

    if (iscurrentState !== "termscondition") {
      setIsTermCondition(false);
    }
    if (iscurrentState !== "affiliated") {
      setIsAffiliated(false);
    }
    if (iscurrentState !== "student-forms") {
      setIsStudentForms(false);
    }

    if (iscurrentState !== "pages") {
      setIsSetting(false);
    }

    if (iscurrentState !== "settings") {
      setIsWaiter(false);
    }
    if (iscurrentState !== "Table") {
      setIsTable(false);
    }
    if (iscurrentState !== "location") {
      setIsBranch(false);
    }
    if (iscurrentState !== "destination-countries") {
      setIsDestination(false);
    }
    if (iscurrentState !== "content-mgmt") {
      setIsContent(false);
    }
    if (iscurrentState !== "database-management") {
      setIsItem(false);
    }

    if (iscurrentState !== "blog") {
      setIsBlog(false);
    }
    if (iscurrentState !== "courses") {
      setIsCourse(false);
    }
    if (iscurrentState !== "menu-setup") {
      setIsMenuSetup(false);
    }
    if (iscurrentState !== "media-mgmt") {
      setIsMedia(false);
    }
    if (iscurrentState !== "privacy-settings") {
      setIsPrivacySettings(false);
    }
    if (iscurrentState !== "messagefromceo") {
      setIsMessage(false);
    }
    if (iscurrentState !== "whoweare") {
      setIsWhoWeAre(false);
    }
    if (iscurrentState !== "email-configuration") {
      setIsConfig(false);
    }
    if (iscurrentState !== "intelligence") {
      setIsIntell(false);
    }
    if (iscurrentState !== "widget-setup") {
      setIsWidget(false);
    }

    if (iscurrentState !== "user-mgmt") {
      setIsUser(false);
    }
    if (isCourseSetup !== "course-management") {
      setIsCourseSetup(false);
    }
    if (isQuiz !== "quizs") {
      setIsQuiz(false);
    }
  }, [
    history,
    isIntell,
    iscurrentState,
    isDashboard,
    isTestimonial,
    isItem,
    isTeam,
    isFAQ,
    isTestimonial,
    isPrivacy,

    isTermCondition,
    isAffiliated,
    isStudentForms,
    isContent,
    isSetting,
    isWaiter,
    isTable,
    isBranch,
    isDestination,
    isBlog,
    isMenuSetup,
    isMedia,
    isConfig,
    isWidget,
    isUser,
    isCourseSetup,
    isQuiz,
  ]);

  const superAdminMenu = [
    {
      label: "Menu",
      isHeader: true,
    },

    {
      id: "Dashboard",
      label: "Dashboard",
      icon: "ri-dashboard-line",
      link: "/dashboard",
      click: function (e) {
        e.preventDefault();
        setIsDashboard(!isDashboard);
        setIscurrentState("Dashboard");
      },
    },

    {
      id: "menu-setup",
      label: "Menu Setup",
      icon: "bx bxs-report",
      link: "/menu-setup",
      parentId: "menu-setup",
      click: (e) => {
        e.preventDefault();
        setIsMenuSetup(!isMenuSetup);
        setIscurrentState("menu-setup");
        updateIconSidebar(e);
      },
      stateVariables: isMenuSetup,
      subItems: [
        {
          id: "menu",
          label: "Menu",
          link: "/menu",
          parentId: "menu-setup",
        },

      ],
    },

    {
      id: "user-mgmt",
      label: "User Management",
      icon: "bx bxs-report",
      link: "/user-mgmt",
      parentId: "user-mgmt",
      click: (e) => {
        e.preventDefault();
        setIsUser(!isUser);
        setIscurrentState("user-mgmt");
        updateIconSidebar(e);
      },
      stateVariables: isUser,
      subItems: [
        {
          id: "user",
          label: "Users",
          link: "/user",
          parentId: "user-mgmt",
        },
        {
          id: "partners",
          label: "Roles",
          link: "/roles",
          parentId: "user-mgmt",
        },
        {
          id: "email-template",
          label: "Email Templates",

          link: "/email-templates",
          parentId: "user-mgmt",
        },
        {
          id: "email-configuration",
          label: "Email Configuration",

          link: "/email-config",
          parentId: "user-mgmt",

        },
        {
          id: "portalManagement",
          label: "Portal Management",
          link: "/portal-management",
          parentId: "user-mgmt",
        },
        {
          id: "emailLogs",
          label: "Email Logs",
          link: "/email-logs",
          parentId: "user-mgmt",
        },
      ],
    },
    {
      id: "media-mgmt",
      label: "Media Management",
      icon: "bx bxs-report",
      link: "/media-mgmt",
      parentId: "media-mgmt",
      click: (e) => {
        e.preventDefault();
        setIsMedia(!isMedia);
        setIscurrentState("media-mgmt");
        updateIconSidebar(e);
      },
      stateVariables: isMedia,
      subItems: [
        {
          id: "mediagroup",
          label: "Media Groups",
          link: "/media-group",
          parentId: "media-mgmt",
        },
        {
          id: "media",
          label: "Media",
          link: "/media-list",
          parentId: "media-mgmt",
        },
      ],
    },
    {
      id: "content-mgmt",
      label: "Content Management",
      icon: "bx bxs-report",
      link: "/content-mgmt",
      parentId: "content-mgmt",
      click: (e) => {
        e.preventDefault();
        setIsContent(!isContent);
        setIscurrentState("content-mgmt");
        updateIconSidebar(e);
      },
      stateVariables: isContent,
      subItems: [
        {
          id: "pages",
          label: "Pages",
          link: "/pages-list",
          parentId: "content-mgmt",
        },
        {
          id: "service",
          label: "Services",
          link: "/service",
          parentId: "content-mgmt",
        },

        {
          id: "product-services",
          label: "Products And Services",
          link: "/product-services",
          parentId: "content-mgmt",
        },
        {
          id: "channel-partners",
          label: "Channel Partners",
          link: "/channel-partners",
          parentId: "content-mgmt",
        },
        {
          id: "destination-country",
          label: "Destination Countries",
          link: "/destination-countries",
          parentId: "content-mgmt",
        },

        {
          id: "affiliated",
          label: "Affiliated Institutes",
          link: "/institute",
          parentId: "content-mgmt",
        },
      ],
    },

    {
      id: "widget-setup",
      label: "Widget Setup",
      icon: "bx bxs-report",
      // link: "/widgets",
      parentId: "widget-setup",
      click: (e) => {
        e.preventDefault();
        setIsWidget(!isWidget);
        setIscurrentState("widget-setup");
        updateIconSidebar(e);
      },
      stateVariables: isWidget,
      subItems: [
        {
          id: "widget-main",
          label: "Widgets",
          link: "/main-widgets",
          parentId: "widget-setup",
        },
        {
          id: "home-widget",
          label: "Page Widgets",
          link: "/home-widget",
          parentId: "widget-setup",
        },
        {
          id: "institute-widget",
          label: "Institute Widgets",
          link: "/institute-widget",
          parentId: "widget-setup",
        },
        {
          id: "destination-widget",
          label: "Destination Widgets",
          link: "/destination-widget",
          parentId: "widget-setup",
        },
        {
          id: "Service-widgets",
          label: "Service Widgets",
          link: "/service-widgets",
          parentId: "widget-setup",
        },
      ],
    },

    {
      id: "course-management",
      label: "Course Management",
      icon: "bx bxs-report",
      link: "/course-management",
      parentId: "course-management",
      click: (e) => {
        e.preventDefault();
        setIsCourseSetup(!isCourseSetup);
        setIscurrentState("course-management");
        updateIconSidebar(e);
      },
      stateVariables: isCourseSetup,
      subItems: [
        {
          id: "course-grps",
          label: "Course Groups",
          link: "/course-group",
          parentId: "course-management",
        },
        {
          id: "course",
          label: "Courses",
          link: "/courses",
          parentId: "course-management",
        },
        {
          id: "quizs",
          label: "Quizs",
          link: "/quiz",
          parentId: "course-management",
        },
        {
          id: "QuickLogs",
          label: "Quiz Logs",
          link: "/quiz-logs",
          parentId: "course-management",
        },
      ],
    },
  ];
  const normalize = (str) =>
    str.replace(/ & /g, "").replace(/\s+/g, "").toLowerCase();

  const filteredMenu = superAdminMenu
    .map((menuItem) => {
      if (
        menuItem.id === "Dashboard" ||
        menuItem?.id === "email-template" ||
        menuItem?.id === "email-config"
      ) {
        return menuItem; // always include Dashboard
      }

      if (menuItem.subItems && menuItem.subItems.length > 0) {
        const filteredSubItems = menuItem.subItems.filter((sub) =>
          menuDynamicList.some(
            (item) => normalize(item) === normalize(sub.label),
          ),
        );

        if (filteredSubItems.length > 0) {
          return { ...menuItem, subItems: filteredSubItems };
        } else {
          return null;
        }
      } else {
        if (
          menuItem.isHeader ||
          menuDynamicList.some(
            (item) => normalize(item) === normalize(menuItem.label),
          )
        ) {
          return menuItem;
        } else {
          return null;
        }
      }
    })
    .filter(Boolean);

  console.log(filteredMenu);
  return <>{filteredMenu}</>;
};

export default Navdata;
